// extracted by mini-css-extract-plugin
export var table = "_us-0";